define('common/ko/fn/waitForValue',['knockout', 'bluebird'], function(ko, Promise) {

    /**
     * Use this to return a promise which resolves when the subscribable has a value
     * @param {Function|undefined} predicate to determine when to resolve that the value has arrived
     * @return {Promise}
     */
    ko.subscribable.fn.waitForValue = function(predicate) {

        var subject = this;

        if (predicate === undefined) {

            predicate = function(value) {
                return value !== null && value !== undefined;
            };

        }

        return new Promise(function(resolve) {

            subject.subscribeAndExec(function(subjectValue, subscription) {

                if (predicate(subjectValue)) {

                    this.dispose();
                    resolve(subjectValue);
                }

            });

        });

    };

});

